import moment from "moment";

/**
 * Date utilities composable
 * Provides common date formatting functions for API calls
 */
export function useDateUtils() {
   /**
    * Formats a date to API DateTime format (YYYY-MM-DDTHH:mm:ss)
    * @param {string|Date|moment.Moment} date - Date to format
    * @returns {string} Formatted date string
    */
   const formatToApiDateTime = (date) => {
      if (!date) return null;
      return moment(date).format("YYYY-MM-DDTHH:mm:ss");
   };

   /**
    * Formats a date to API Date format (YYYY-MM-DD)
    * @param {string|Date|moment.Moment} date - Date to format
    * @returns {string} Formatted date string
    */
   const formatToApiDate = (date) => {
      if (!date) return null;
      return moment(date).format("YYYY-MM-DD");
   };

   return {
      formatToApiDateTime,
      formatToApiDate,
   };
}
